import axios from '../../utils/axiosConfig';
// import axios from 'axios';
import { setAlert } from './alertActions';
import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  USER_LOADED_REQUEST,
  USER_LOADED_SUCCESS,
  USER_LOADED_FAIL,
  AUTH_ERROR,
} from '../constants/authConstants';
import { FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_FAIL, UPDATE_USER_PERMISSION_REQUEST, UPDATE_USER_PERMISSION_SUCCESS, UPDATE_USER_PERMISSION_FAIL } from '../constants/userConstants';

import setAuthToken from '../utils/setAuthToken';
// actions/userActions.js
// import { FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_FAIL } from '../constants/userConstants';

export const fetchUsers = () => async (dispatch) => {
  dispatch({ type: FETCH_USERS_REQUEST });

  try {
    const res = await axios.get('/api/users');
    dispatch({
      type: FETCH_USERS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USERS_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

export const updateUserPermission = (id, isActive) => async (dispatch) => {
  dispatch({ type: UPDATE_USER_PERMISSION_REQUEST });

  try {
    const res = await axios.put(`/api/users/${id}/permission`, { isActive });
    dispatch({
      type: UPDATE_USER_PERMISSION_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: UPDATE_USER_PERMISSION_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Load User
export const loadUser = () => async (dispatch) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  // console.log('load user calling api');
  dispatch({ type: USER_LOADED_REQUEST });

  try {
    const res = await axios.get('/api/auth');
    dispatch({
      type: USER_LOADED_SUCCESS,
      payload: res.data,
    });
    // Temporarily disabled to prevent infinite loops
    // startCheckingUserStatus(dispatch);
    // console.log('user loaded', res.data);
  } catch (err) {
    dispatch({
      type: USER_LOADED_FAIL,
    });
  }
};

// Register User
export const register = ({ firstName, middleName, lastName, email, role, password, relationship, keepLoggedIn, avatar }) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const body = JSON.stringify({ firstName, middleName, lastName, email, role, password, relationship, keepLoggedIn, avatar });
  console.log(body);
  dispatch({ type: REGISTER_REQUEST });

  try {
    const res = await axios.post('/api/auth/signup', body, config);

    dispatch({
      type: REGISTER_SUCCESS,
      payload: res.data,
    });

    dispatch(loadUser());
  } catch (err) {
    console.log(err);
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: REGISTER_FAIL,
    });
  }
};

// Login User
export const login = (email, password) => async (dispatch) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const body = JSON.stringify({ email, password });

  dispatch({ type: LOGIN_REQUEST });

  try {
    // console.log('login calling api');
    const res = await axios.post('/api/auth/login', body, config);
    console.log('login response', res.data);
    const { token, user } = res.data;
    // console.log('user is', user);
        // Check if the user is active
        if (!res.data.user.isActive) {
          // dispatch({
          //   type: LOGIN_FAIL,
          // });
          alert('Your account is inactive. Please contact the administrator.', 'danger');
          return;
        }
    
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data,
    });
    // console.log('token is', res.data.token);
    // Store the token in local storage
    localStorage.setItem('token', res.data.token);
    dispatch(loadUser());
    // Temporarily disabled to prevent infinite loops
    // startCheckingUserStatus(dispatch);
  } catch (err) {
    const errors = err?.response?.data?.errors;

    if (errors) {
      errors.forEach((error) => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: LOGIN_FAIL,
    });
  }
};

// Logout
export const logout = () => (dispatch) => {
  localStorage.removeItem('token');
  dispatch({ type: 'LOGOUT' });
};

// Function to periodically check user status
const startCheckingUserStatus = (dispatch) => {
  setInterval(async () => {
    try {
      const res = await axios.get('/api/auth/check-status');
      const { isActive } = res.data;

      if (!isActive) {
        dispatch(logout());
        alert('Your access has been revoked. You have been logged out.');
      }
    } catch (err) {
      console.error('Error checking user status', err);
    }
  }, 60000); // Check every 60 seconds
};